import PropTypes from "prop-types";
import useSettings from "@/hooks/useSettings";

const Template4 = ({ template, previewData }) => {
  const {
    settings: { restaurant = {} },
  } = useSettings();
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage =
    template?.image_url ||
    template?.image?.file_url ||
    template?.file_url ||
    previewData?.image_url ||
    previewData?.image?.file_url ||
    previewData?.template?.image_url ||
    previewData?.template?.image?.file_url ||
    null;
  const restaurantName =
    restaurant?.outlet_name ||
    restaurant?.legal_name ||
    previewData?.restaurantName ||
    previewData?.businessName ||
    previewData?.restaurant_name ||
    (isStrictPreview ? "No provide" : "NAGA INDIAN");
  const address =
    restaurant?.address ||
    previewData?.address ||
    previewData?.restaurant_address ||
    (isStrictPreview
      ? "No provide"
      : "68 Brick Ln, London E1 6RL, United Kingdom");
  const phone =
    restaurant?.phone ||
    previewData?.phone ||
    previewData?.restaurant_phone ||
    (isStrictPreview ? "No provide" : "011-23236767");
  const tin =
    restaurant?.vat_id ||
    previewData?.tin ||
    previewData?.restaurant_tin ||
    (isStrictPreview ? "No provide" : "00000000");
  const website =
    restaurant?.website ||
    previewData?.website ||
    previewData?.restaurant_website ||
    (isStrictPreview ? "No provide" : "www.demo.com");
  const moto = restaurant?.moto || previewData?.restaurant_moto || null;
  const bid = restaurant?.bid || previewData?.restaurant_bid || null;
  const title =
    previewData?.title || previewData?.note || (isStrictPreview ? "No provide" : "Gift Voucher");
  const customerName =
    previewData?.customerName ||
    previewData?.customer_name ||
    previewData?.receiver_full_name ||
    previewData?.receiver?.full_name ||
    (isStrictPreview ? "No provide" : "Md Rasel Mahmud");
  const payerName =
    previewData?.payer_full_name ||
    previewData?.payer?.full_name ||
    previewData?.fromName ||
    previewData?.previewMessage ||
    null;
  const code = previewData?.code || (isStrictPreview ? "No provide" : "326562356");
  const reward = previewData?.reward ?? previewData?.reward_amount ?? null;
  const rewardLabel = previewData?.rewardLabel || (isStrictPreview ? null : "Double Points");
  const eligibleRewardPoints = previewData?.eligibleRewardPoints || (isStrictPreview ? null : "50");
  const minimumRequiredPoints = previewData?.minimumRequiredPoints || (isStrictPreview ? null : "20");
  const isConjunction = previewData?.isConjunction ?? previewData?.is_conjunction ?? (isStrictPreview ? false : true);
  const message =
    previewData?.message ||
    previewData?.template_note ||
    previewData?.note ||
    (isStrictPreview ? "No provide" : "Wish you a happy day.");

  const isDiscount = rewardLabel && (rewardLabel.includes("£") || rewardLabel.includes("%") || rewardLabel.toLowerCase().includes("off"));
  const offerSentence = rewardLabel 
    ? (isDiscount ? `For ${eligibleRewardPoints} points get ${rewardLabel} off` : `For ${eligibleRewardPoints} points get ${rewardLabel}`)
    : `For ${eligibleRewardPoints} points get reward`;
  const eligibilitySentence = `Minimum ${minimumRequiredPoints} points to be eligible for this offer`;

  return (
    <div className="flex items-center justify-center bg-white p-4">
      <div
        data-export-capture="c2c-template"
        className="w-full max-w-[420px] bg-white p-4 font-mono text-black bg-cover bg-center"
        style={
          backgroundImage
            ? { backgroundImage: `url(${backgroundImage})` }
            : undefined
        }
      >
        <div className="space-y-3 bg-white">
          <div className="space-y-1 text-center leading-tight">
            <h1 className="text-[24px] font-extrabold uppercase tracking-tight">
              {restaurantName}
            </h1>
            {moto ? <p className="text-[14px] font-bold">{moto}</p> : null}
            {bid ? <p className="text-[14px] font-bold">BID : {bid}</p> : null}
            <p className="text-[16px] font-bold">{address}</p>
            <p className="text-[16px] font-bold">Phone : {phone}</p>
            <p className="text-[16px] font-bold">TIN No : {tin}</p>
            <p className="text-[16px] font-bold">website: {website}</p>
          </div>

          <div className="border-t border-dashed border-black" />

          <div className="space-y-3 pt-1 text-[18px] font-bold leading-tight">
            <p className="text-[20px]">{title}</p>
            <p>{customerName}</p>
            {payerName ? <p>From: {payerName}</p> : null}
            {previewData?.eligibleRewardPoints || previewData?.minimumRequiredPoints ? (
              <>
                <p>{offerSentence}</p>
                <p>{eligibilitySentence}</p>
              </>
            ) : (
              <>
                {rewardLabel ? (
                  <p>Offer: {rewardLabel}</p>
                ) : reward !== null && reward !== undefined && reward !== "" ? (
                  <p>Reward: £ {reward}</p>
                ) : null}
              </>
            )}
            <p>Code: {code}</p>
            {message ? <p>“{message}”</p> : null}
            {isConjunction && (
              <p className="text-[14px]">Not conjunction with any other offer</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Template4.propTypes = {
  template: PropTypes.shape({
    image_url: PropTypes.string,
  }),
  previewData: PropTypes.shape({
    strictTablePreview: PropTypes.bool,
    restaurantName: PropTypes.string,
    businessName: PropTypes.string,
    restaurant_name: PropTypes.string,
    address: PropTypes.string,
    restaurant_address: PropTypes.string,
    phone: PropTypes.string,
    restaurant_phone: PropTypes.string,
    tin: PropTypes.string,
    restaurant_tin: PropTypes.string,
    website: PropTypes.string,
    restaurant_website: PropTypes.string,
    title: PropTypes.string,
    note: PropTypes.string,
    customerName: PropTypes.string,
    customer_name: PropTypes.string,
    receiver_full_name: PropTypes.string,
    receiver: PropTypes.shape({
      full_name: PropTypes.string,
    }),
    payer_full_name: PropTypes.string,
    payer: PropTypes.shape({
      full_name: PropTypes.string,
    }),
    fromName: PropTypes.string,
    previewMessage: PropTypes.string,
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reward: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reward_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rewardLabel: PropTypes.string,
    eligibleRewardPoints: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minimumRequiredPoints: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isConjunction: PropTypes.bool,
    is_conjunction: PropTypes.bool,
    message: PropTypes.string,
    template_note: PropTypes.string,
  }),
};

export default Template4;
